export default {
  path: '/workHoursInfo',
  component: () => import(/* webpackChunkName: 'layout' */'@/views/workHoursInfo/layout/index'),
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      name: 'workHoursInfo',
      component: () => import(/* webpackChunkName: 'user' */'@/views/workHoursInfo/index')
    }
  ]
}
